var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mpd-status-bar"},[(_vm.messageInfo.content)?[_c('span',[_vm._v("提示信息("+_vm._s(_vm.messageInfo.type)+")：")]),_c('span',[_vm._v(_vm._s(_vm.messageInfo.content))])]:[_c('span',[_vm._v("暂无提示")])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }